import { render } from "./DetaildViewMonthly.vue?vue&type=template&id=2ce85ca2&scoped=true"
import script from "./DetaildViewMonthly.vue?vue&type=script&lang=js"
export * from "./DetaildViewMonthly.vue?vue&type=script&lang=js"

import "./DetaildViewMonthly.vue?vue&type=style&index=0&id=2ce85ca2&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce85ca2"]])

export default __exports__